import React from 'react';
import { Training } from '../../services/firebase/training.service';
import ShareTraining from './ShareTraining';

interface ShareTrainingModalProps {
  isOpen: boolean;
  onClose: () => void;
  training: Training | null;
  onSuccess?: () => void;
}

const ShareTrainingModal: React.FC<ShareTrainingModalProps> = ({
  isOpen,
  onClose,
  training,
  onSuccess
}) => {
  if (!isOpen || !training) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div 
        className="animate-fadeIn"
        onClick={(e) => e.stopPropagation()}
      >
        <ShareTraining 
          training={training}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      </div>
    </div>
  );
};

export default ShareTrainingModal;